import React, { useRef } from "react";
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, chakra, shouldForwardProp, } from "@chakra-ui/react";
import { motion, MotionConfig, isValidMotionProp } from "framer-motion";
import { Fireworks } from "@fireworks-js/react";
import { UpsellButton } from "./upsell-button";
const MotionBox = chakra(motion.div, {
    shouldForwardProp(prop) {
        return isValidMotionProp(prop) || shouldForwardProp(prop);
    },
});
const MotionSvg = chakra(motion.svg, {
    shouldForwardProp(prop) {
        return isValidMotionProp(prop) || shouldForwardProp(prop);
    },
});
export function UpsellSuccessDialog({ isOpen, title, children, buttonText, onClose, }) {
    const closeButton = useRef(null);
    return (React.createElement(MotionConfig, { transition: { duration: 5 } },
        React.createElement(AlertDialog, { isOpen: isOpen, leastDestructiveRef: closeButton, onClose: onClose },
            React.createElement(AlertDialogOverlay, null,
                React.createElement(Box, { as: Fireworks, options: { opacity: 0.5, intensity: 15 }, position: "fixed", width: "100%", height: "100%", top: 0, left: 0, bg: "rgba(49, 56, 73, 0.8)" }),
                React.createElement(AlertDialogContent, { w: "sm", motionProps: {
                        initial: {
                            scale: 0.9,
                            opacity: 0,
                        },
                        variants: {
                            enter: {
                                scale: 1,
                                opacity: 1,
                                transition: {
                                    type: "spring",
                                    damping: 30,
                                    stiffness: 1600,
                                },
                            },
                            exit: {
                                scale: 0.9,
                                opacity: 0,
                                transition: {
                                    type: "spring",
                                    duration: 0.15,
                                },
                            },
                        },
                    } },
                    React.createElement(Box, { boxSize: 16, position: "relative", mx: "auto", display: "flex", alignItems: "center", justifyContent: "center" },
                        React.createElement(MotionBox, { position: "absolute", top: 0, left: 0, zIndex: 1, width: 16, height: 16, borderRadius: "full", bg: "grass.200", initial: {
                                scale: 0,
                                opacity: 1,
                            }, animate: {
                                scale: 1.5,
                                opacity: 0,
                            }, 
                            // @ts-expect-error Framer Motion overrides Chakra's `transition` prop
                            transition: {
                                scale: {
                                    type: "spring",
                                    damping: 30,
                                    stiffness: 50,
                                    delay: 0.3,
                                },
                                opacity: {
                                    type: "tween",
                                    duration: 1.8,
                                    delay: 0.3,
                                },
                            } }),
                        React.createElement(MotionBox, { boxSize: 14, zIndex: 2, borderRadius: "full", bg: "grass.200", display: "flex", alignItems: "center", justifyContent: "center", initial: {
                                scale: 0.5,
                                opacity: 0,
                            }, animate: {
                                scale: 1,
                                opacity: 1,
                            }, 
                            // @ts-expect-error Framer Motion overrides Chakra's `transition` prop
                            transition: {
                                type: "spring",
                                damping: 30,
                                stiffness: 600,
                                delay: 0.3,
                            } },
                            React.createElement(MotionSvg, { boxSize: 8, fill: "none", viewBox: "0 0 24 24", stroke: "grass.600", strokeWidth: "2.5", strokeDasharray: "30", initial: {
                                    strokeDashoffset: 30,
                                }, animate: {
                                    strokeDashoffset: 0,
                                }, 
                                // @ts-expect-error Framer Motion overrides Chakra's `transition` prop
                                transition: {
                                    type: "spring",
                                    damping: 50,
                                    stiffness: 300,
                                    delay: 0.6,
                                } },
                                React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M4.5 12.75l6 6 9-13.5" })))),
                    React.createElement(AlertDialogHeader, { mt: 4, textAlign: "center" }, title),
                    React.createElement(AlertDialogBody, { textAlign: "center" }, children),
                    React.createElement(AlertDialogFooter, null,
                        React.createElement(UpsellButton, { ref: closeButton, isJustified: true, onClick: onClose }, buttonText)))))));
}
